@if (this.regionData?.result$ | async; as result) {
    @if (result.value?.data; as regionData) {
        @if (result.isLoading) {
            <cll-spinner />
        }

        @if (result.error; as error) {
            <app-error-panel [error]="error" />
        }

        <div class="accordion-container">
            <cll-card-divider />

            <div class="accordion-row-field">
                <app-accordion-item [label]="'Region reference'" [data]="regionData.reference"/>
            </div>
            
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Region name'" [data]="regionData.name"/>
            </div>

            <cll-card-footer>
                @if ((user()?.permissions?.permissions ?? []).includes('region.update')) {
                    <button cll-tonal-button (click)="editDetails()">
                        <cll-icon cllButtonIcon type="outlined" [size]="20">edit</cll-icon>
                        Edit
                    </button>
                }
            </cll-card-footer>
        </div>

    }
}
